"use strict";
/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2020
 * @license MIT
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var hooks_1 = require("./hooks");
exports.ContextMenuWrapper = react_1.default.memo(function (_a) {
    var id = _a.id, global = _a.global, children = _a.children, onShow = _a.onShow, onHide = _a.onHide, hideOnSelfClick = _a.hideOnSelfClick, hideOnOutsideClick = _a.hideOnOutsideClick, hideOnEscape = _a.hideOnEscape, hideOnScroll = _a.hideOnScroll, hideOnWindowResize = _a.hideOnWindowResize, _b = _a.wrapperStyle, wrapperStyle = _b === void 0 ? {} : _b;
    var wrapperRef = react_1.useRef();
    var _c = react_1.useState(null), lastShowMenuEvent = _c[0], setShowMenuEvent = _c[1];
    var _d = react_1.useState(null), placementStyle = _d[0], setMenuPlacementStyle = _d[1];
    var _e = hooks_1.useMenuToggleMethods(lastShowMenuEvent, setShowMenuEvent, onShow, onHide), showMenu = _e[0], hideMenu = _e[1];
    hooks_1.useInternalHandlers(wrapperRef, lastShowMenuEvent, showMenu, hideMenu, id, global, hideOnSelfClick, hideOnOutsideClick, hideOnEscape, hideOnScroll, hideOnWindowResize);
    hooks_1.useMenuPlacementStyle(wrapperRef, lastShowMenuEvent, setMenuPlacementStyle);
    if (!lastShowMenuEvent)
        return null;
    var style = __assign(__assign({ position: 'fixed', zIndex: 999, left: -9999, top: -9999 }, wrapperStyle), placementStyle);
    return react_dom_1.createPortal(react_1.default.createElement("div", { ref: wrapperRef, style: style },
        react_1.default.createElement(hooks_1.ContextMenuEventContext.Provider, { value: lastShowMenuEvent }, children)), document.body);
});
exports.ContextMenuWrapper.defaultProps = {
    id: undefined,
    global: false,
    onShow: undefined,
    onHide: undefined,
    hideOnSelfClick: true,
    hideOnOutsideClick: true,
    hideOnEscape: true,
    hideOnScroll: true,
    hideOnWindowResize: true,
};
//# sourceMappingURL=ContextMenuWrapper.js.map